import { isImmutable } from 'immutable';
export function getPersonLastCheckin(checkins) {
    var _a, _b;
    if (isImmutable(checkins)) {
        return (_a = checkins === null || checkins === void 0 ? void 0 : checkins.get(0)) !== null && _a !== void 0 ? _a : undefined;
    }
    return (_b = checkins === null || checkins === void 0 ? void 0 : checkins[0]) !== null && _b !== void 0 ? _b : undefined;
}
